export enum TenantStatus {
  ACTIVE = 1,
  INACTIVE = 3,
  DELETE = 0,
}

export const TenantStatusOptions = [
  {
    label: "Active",
    value: TenantStatus.ACTIVE,
  },
  {
    label: "Inactive",
    value: TenantStatus.INACTIVE,
  },
];
